import { createContext, useContext } from 'react'

export const BotSettingsContext = createContext({
  display_name: ''
})

export const useBotSettingsContext = () => useContext(BotSettingsContext)
